module.exports = __webpack_public_path__ + "img/question_icon.fc98eb8e.png";